import { createIcon } from '../icon'
import ExclamationIcon from '@/components/atoms/svg/ExclamationIcon'

export const ExclamationIconDefault = createIcon(ExclamationIcon)
